"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toJalali = void 0;
var date_splicer_1 = require("../date-splicer/date-splicer");
var in_winter_1 = require("./in-winter");
var how_many_days_are_past_1 = require("./how-many-days-are-past");
var spring_calculation_1 = require("./spring-calculation");
var winter_calculation_1 = require("./winter-calculation");
var jalali_validation_1 = require("../validation/jalali-validation");
var getNumeric_1 = require("../getNumeric");
var getDay_1 = require("../getDay");
function toJalali(date) {
    var _a = date_splicer_1.dateSplicer(date), year = _a.year, month = _a.month, day = _a.day, hour = _a.hour, minute = _a.minute, second = _a.second, miliSecond = _a.miliSecond;
    var _b = jalali_validation_1.jalaliValidation(year, month, day, hour, minute, second, miliSecond), staus = _b.staus, YEAR = _b.YEAR, MONTH = _b.MONTH, DAY = _b.DAY, HOUR = _b.HOUR, MINUTE = _b.MINUTE, SECOND = _b.SECOND, MILISECOND = _b.MILISECOND;
    if (!staus) {
        return {
            year: 0,
            month: 0,
            day: 0,
            hour: 0,
            minute: 0,
            second: 0,
            miliSecond: 0,
            numeric: 0,
            dayName: -1
        };
    }
    else {
        var Days = how_many_days_are_past_1.howManyDaysArePast(YEAR, MONTH, DAY);
        var NUMERIC = getNumeric_1.getNumeric(YEAR, MONTH, DAY, HOUR, MINUTE, SECOND, MILISECOND);
        var DAY_NAME = getDay_1.getDay(YEAR, MONTH, DAY, HOUR, MINUTE, SECOND, MILISECOND);
        if (in_winter_1.inWinter(Days)) {
            return __assign(__assign({}, winter_calculation_1.winterCalculation(YEAR, Days)), { hour: HOUR, minute: MINUTE, second: SECOND, miliSecond: MILISECOND, numeric: NUMERIC, dayName: DAY_NAME });
        }
        else {
            return __assign(__assign({}, spring_calculation_1.springCalculation(YEAR, Days)), { hour: HOUR, minute: MINUTE, second: SECOND, miliSecond: MILISECOND, numeric: NUMERIC, dayName: DAY_NAME });
        }
    }
}
exports.toJalali = toJalali;
